import styled from "@emotion/styled";
import { useMemo } from "react";
import { Accordion } from "react-bootstrap";
import { FaRegDotCircle } from "react-icons/fa";
import ColorBox from "../ColorBox";

const ModalContentContainer = styled.div`
    .accordion-item {
        border-width: 0;
    }

    .accordion-button:not(.collapsed) {
        color: inherit;
        background-color: transparent;
    }
`;

export default function ModalComponent({ data }) {
    const items = useMemo(() => {
        const colors = ["var(--bs-primary)", "var(--bs-orange)", "var(--bs-success)", "var(--bs-info)", "var(--bs-indigo)", "var(--bs-yellow)"];

        const sets = [
            {
                name: "Sequence",
                body: (
                    <>
                        <div className="row">
                            <ModalDetail title="sequence_name" text={data?.sequence_name ?? "-"} />
                            <ModalDetail title="sequence_description" text={data?.sequence_description ?? "-"} />
                            <ModalDetail title="sequence_length" text={data?.sequence_length ?? "-"} />
                        </div>

                        <div className="row">
                            <ModalDetailFullWidth title="sequence_data" text={data?.sequence_data ?? "-"} />
                        </div>
                    </>
                ),
            },
            {
                name: "Blast",
                body: (
                    <>
                        <div className="row">
                            <ModalDetail title="blast_database" text={data?.blast_database ?? "-"} />
                            <ModalDetail title="blast_hits_count" text={data?.blast_hits_count ?? "-"} />
                            <ModalDetail title="blast_min_e_value" text={data?.blast_min_e_value ?? "-"} />
                            <ModalDetail title="blast_similarity_mean" text={data?.blast_similarity_mean ?? "-"} />
                            <ModalDetail title="blast_top_hit_accession" text={data?.blast_top_hit_accession ?? "-"} />
                            <ModalDetail title="blast_top_hit_alignment_length" text={data?.blast_top_hit_alignment_length ?? "-"} />
                            <ModalDetail title="blast_top_hit_description_hsp" text={data?.blast_top_hit_description_hsp ?? "-"} />
                            <ModalDetail title="blast_top_hit_e_value" text={data?.blast_top_hit_e_value ?? "-"} />
                            <ModalDetail title="blast_top_hit_frame" text={data?.blast_top_hit_frame ?? "-"} />
                            <ModalDetail title="blast_top_hit_gene_identifier" text={data?.blast_top_hit_gene_identifier ?? "-"} />
                            <ModalDetail title="blast_top_hit_hs_ps_number" text={data?.blast_top_hit_hs_ps_number ?? "-"} />
                            <ModalDetail title="blast_top_hit_hsp_end" text={data?.blast_top_hit_hsp_end ?? "-"} />
                            <ModalDetail title="blast_top_hit_hsp_hit" text={data?.blast_top_hit_hsp_hit ?? "-"} />
                            <ModalDetail title="blast_top_hit_hsp_query" text={data?.blast_top_hit_hsp_query ?? "-"} />
                            <ModalDetail title="blast_top_hit_hsp_start" text={data?.blast_top_hit_hsp_start ?? "-"} />
                            <ModalDetail title="blast_top_hit_length" text={data?.blast_top_hit_length ?? "-"} />
                            <ModalDetail title="blast_top_hit_positives" text={data?.blast_top_hit_positives ?? "-"} />
                            <ModalDetail title="blast_top_hit_query_start" text={data?.blast_top_hit_query_start ?? "-"} />
                            <ModalDetail title="blast_top_hit_query_end" text={data?.blast_top_hit_query_end ?? "-"} />
                            <ModalDetail title="blast_top_hit_score" text={data?.blast_top_hit_score ?? "-"} />
                            <ModalDetail title="blast_top_hit_similarity" text={data?.blast_top_hit_similarity ?? "-"} />
                            <ModalDetail title="blast_top_hit_taxonomy_name" text={data?.blast_top_hit_taxonomy_name ?? "-"} />
                        </div>
                    </>
                ),
            },
            {
                name: "Mapping",
                body: (
                    <>
                        <div className="row">
                            <ModalDetailFullWidth title="mapping_taxa_id" text={data?.mapping_taxa_id ?? '-'} />
                            <ModalDetailFullWidth title="mapping_go_category" text={data?.mapping_go_category ?? "-"} />
                            <ModalDetailFullWidth title="mapping_gene_name" text={data?.mapping_gene_name ?? "-"} />
                            <ModalDetailFullWidth title="mapping_go_id" text={data?.mapping_go_id ?? "-"} />
                            <ModalDetailFullWidth title="mapping_go_term" text={data?.mapping_go_term ?? "-"} />
                            <ModalDetailFullWidth title="mapping_x_ref" text={data?.mapping_x_ref ?? "-"} />
                            <ModalDetailFullWidth title="mapping_x_ref_database" text={data?.mapping_x_ref_database ?? "-"} />
                        </div>
                    </>
                ),
            },
            {
                name: "Inter Pro",
                body: (
                    <>
                        <div className="row">
                            <ModalDetail title="inter_pro_accession" text={data?.inter_pro_accession ?? "-"} />
                            <ModalDetail title="inter_pro_go_category" text={data?.inter_pro_go_category ?? "-"} />
                            <ModalDetail title="inter_pro_go_id" text={data?.inter_pro_go_id ?? "-"} />
                            <ModalDetail title="inter_pro_go_term" text={data?.inter_pro_go_term ?? "-"} />
                            <ModalDetail title="inter_pro_name" text={data?.inter_pro_name ?? "-"} />
                            <ModalDetail title="inter_pro_signatures" text={data?.inter_pro_signatures ?? "-"} />
                            <ModalDetail title="inter_pro_type" text={data?.inter_pro_type ?? "-"} />
                        </div>
                    </>
                ),
            },
            {
                name: "Annotation",
                body: (
                    <>
                        <div className="row">
                            <ModalDetail title="annotation_go_category" text={data?.annotation_go_category ?? "-"} />
                            <ModalDetail title="annotation_go_count" text={data?.annotation_go_count ?? "-"} />
                            <ModalDetail title="annotation_go_id" text={data?.annotation_go_id ?? "-"} />
                            <ModalDetail title="annotation_go_term" text={data?.annotation_go_term ?? "-"} />
                        </div>
                    </>
                ),
            },
            {
                name: "Enzyme",
                body: (
                    <>
                        <div className="row">
                            <ModalDetail title="enzyme_code" text={data?.enzyme_code ?? "-"} />
                            <ModalDetail title="enzyme_name" text={data?.enzyme_name ?? "-"} />
                        </div>
                    </>
                ),
            },
        ];

        sets.forEach((v, i) => {
            v.color = colors[i];
        });

        return sets;
    }, []);

    return (
        <ModalContentContainer>
            <div className="container-fluid font-monospace">
                <div className="d-flex flex-column gap-3">
                    {items.map((v, i) => (
                        <Accordion key={i} defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <div className="d-flex gap-2 align-items-center">
                                        <ColorBox color={v.color} />
                                        <span className="h5 m-0">{v.name}</span>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>{v.body}</Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    ))}

                    {/* 
                <div className="d-flex gap-2 align-items-center">
                    <ColorBox />
                    <span className="h3 m-0">Sequence</span>
                </div>

                <div className="bg-primary mb-3" style={{ height: 5 }}></div>

                <div className="row">
                    <ModalDetail title="sequence_name" text={data?.sequence_name ?? "-"} />
                    <ModalDetail title="sequence_description" text={data?.sequence_description ?? "-"} />
                    <ModalDetail title="sequence_length" text={data?.sequence_length ?? "-"} />
                </div>

                <div className="row">
                    <ModalDetailFullWidth title="sequence_data" text={data?.sequence_data ?? "-"} />
                </div>

                <div className="h3 mt-3 mb-3">Blast</div>
                <div className="row">
                    <ModalDetail title="blast_database" text={data?.blast_database ?? "-"} />
                    <ModalDetail title="blast_hits_count" text={data?.blast_hits_count ?? "-"} />
                    <ModalDetail title="blast_min_e_value" text={data?.blast_min_e_value ?? "-"} />
                    <ModalDetail title="blast_similarity_mean" text={data?.blast_similarity_mean ?? "-"} />
                    <ModalDetail title="blast_top_hit_accession" text={data?.blast_top_hit_accession ?? "-"} />
                    <ModalDetail title="blast_top_hit_alignment_length" text={data?.blast_top_hit_alignment_length ?? "-"} />
                    <ModalDetail title="blast_top_hit_description_hsp" text={data?.blast_top_hit_description_hsp ?? "-"} />
                    <ModalDetail title="blast_top_hit_e_value" text={data?.blast_top_hit_e_value ?? "-"} />
                    <ModalDetail title="blast_top_hit_frame" text={data?.blast_top_hit_frame ?? "-"} />
                    <ModalDetail title="blast_top_hit_gene_identifier" text={data?.blast_top_hit_gene_identifier ?? "-"} />
                    <ModalDetail title="blast_top_hit_hs_ps_number" text={data?.blast_top_hit_hs_ps_number ?? "-"} />
                    <ModalDetail title="blast_top_hit_hsp_end" text={data?.blast_top_hit_hsp_end ?? "-"} />
                    <ModalDetail title="blast_top_hit_hsp_hit" text={data?.blast_top_hit_hsp_hit ?? "-"} />
                    <ModalDetail title="blast_top_hit_hsp_query" text={data?.blast_top_hit_hsp_query ?? "-"} />
                    <ModalDetail title="blast_top_hit_hsp_start" text={data?.blast_top_hit_hsp_start ?? "-"} />
                    <ModalDetail title="blast_top_hit_length" text={data?.blast_top_hit_length ?? "-"} />
                    <ModalDetail title="blast_top_hit_positives" text={data?.blast_top_hit_positives ?? "-"} />
                    <ModalDetail title="blast_top_hit_query_start" text={data?.blast_top_hit_query_start ?? "-"} />
                    <ModalDetail title="blast_top_hit_query_end" text={data?.blast_top_hit_query_end ?? "-"} />
                    <ModalDetail title="blast_top_hit_score" text={data?.blast_top_hit_score ?? "-"} />
                    <ModalDetail title="blast_top_hit_similarity" text={data?.blast_top_hit_similarity ?? "-"} />
                    <ModalDetail title="blast_top_hit_taxonomy_name" text={data?.blast_top_hit_taxonomy_name ?? "-"} />
                </div>

                <div className="h3 mt-3 mb-3">Mapping</div>
                <div className="row">
                    <ModalDetail title="mapping_taxa_id" text={data?.mapping_taxa_id ?? "-"} />
                    <ModalDetail title="mapping_gene_name" text={data?.mapping_gene_name ?? "-"} />
                    <ModalDetail title="mapping_go_category" text={data?.mapping_go_category ?? "-"} />
                    <ModalDetail title="mapping_go_id" text={data?.mapping_go_id ?? "-"} />
                    <ModalDetail title="mapping_go_term" text={data?.mapping_go_term ?? "-"} />
                    <ModalDetail title="mapping_x_ref" text={data?.mapping_x_ref ?? "-"} />
                    <ModalDetail title="mapping_x_ref_database" text={data?.mapping_x_ref_database ?? "-"} />
                </div>

                <div className="h3 mt-3 mb-3">Inter Pro</div>
                <div className="row">
                    <ModalDetail title="inter_pro_accession" text={data?.inter_pro_accession ?? "-"} />
                    <ModalDetail title="inter_pro_go_category" text={data?.inter_pro_go_category ?? "-"} />
                    <ModalDetail title="inter_pro_go_id" text={data?.inter_pro_go_id ?? "-"} />
                    <ModalDetail title="inter_pro_go_term" text={data?.inter_pro_go_term ?? "-"} />
                    <ModalDetail title="inter_pro_name" text={data?.inter_pro_name ?? "-"} />
                    <ModalDetail title="inter_pro_signatures" text={data?.inter_pro_signatures ?? "-"} />
                    <ModalDetail title="inter_pro_type" text={data?.inter_pro_type ?? "-"} />
                </div>

                <div className="h3 mt-3 mb-3">Annotation</div>
                <div className="row">
                    <ModalDetail title="annotation_go_category" text={data?.annotation_go_category ?? "-"} />
                    <ModalDetail title="annotation_go_count" text={data?.annotation_go_count ?? "-"} />
                    <ModalDetail title="annotation_go_id" text={data?.annotation_go_id ?? "-"} />
                    <ModalDetail title="annotation_go_term" text={data?.annotation_go_term ?? "-"} />
                </div>

                <div className="h3 mt-3 mb-3">Enzyme</div>
                <div className="row">
                    <ModalDetail title="enzyme_code" text={data?.enzyme_code ?? "-"} />
                    <ModalDetail title="enzyme_name" text={data?.enzyme_name ?? "-"} />
                </div> */}
                </div>
            </div>
        </ModalContentContainer>
    );
}

function TextSplit(props) {
    return <div className="d-flex flex-wrap gap-2">
        {props?.text?.split(";").map((v) => {
        return <span>{v},</span>;
    })}
    </div>;
}

function ModalDetail({ title, text }) {
    return (
        <div className="col-12 col-md-6 col-xl-4 col-xxl-3 mb-4">
            <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                <div className="mx-2">
                    <FaRegDotCircle className="text-primary" />
                </div>
                <div className="font-monospace">{title}</div>
            </div>
            <div className="bg-light p-1 rounded font-monospace" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word" }}>
                {text}
            </div>
        </div>
    );
}

function ModalDetailFullWidth({ title, text }) {
    return (
        <div className="col-12 mb-4">
            <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                <div className="mx-2">
                    <FaRegDotCircle className="text-primary" />
                </div>
                <div className="font-monospace">{title}</div>
            </div>
            <div className="bg-light p-1 rounded font-monospace" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word" }}>
                {text}
            </div>
        </div>
    );
}
